module.exports = __webpack_public_path__ + "static/media/maestro.999b456f.svg";